import script from "./TimeUsage.vue?vue&type=script&setup=true&lang=ts"
export * from "./TimeUsage.vue?vue&type=script&setup=true&lang=ts"

import "./TimeUsage.vue?vue&type=style&index=0&id=426f07ca&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-426f07ca"]])

export default __exports__